import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import AccordionComponent from "../../../../common/Accordion";
import StakeholderCardDetails from "../../../../common/StakeholderCardDetails";
import {
  CASE_STAGE_STATUS,
  PARTY_TYPES,
  SERVICE_PROVIDER_DEFAULT,
  STAKEHOLDER_LIST_CODE,
} from "../../../../common/Constant";
import { TEAM_MEMBERS_HEADERS } from "../../Case_Information/actions/Constant";
import {
  addCaseStakeholderDetails,
  fetchCaseStakeholderAddressList,
  fetchCaseStakeholderContactList,
  fetchCaseStakeholderDetails,
  fetchCaseStakeholderList,
  updateCaseStakeholderDetails,
  fetchCaseTeamHODDetails,
} from "../../../../services/CaseInformationApi";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import Snackbar from "../../../../common/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import Loader from "../../../../common/Loader";
import {
  setClient_StakeholderId,
  setClientId,
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../redux/slice/CaseHeaderSlice";
import DataTable from "../../../../common/DataTable";
import NewPartiesDrawer from "./NewPartiesDrawer";
import AddNewPartyClient from "./AddNewPartyClient";
import { fetchCaseStages } from "../../../../redux/slice/caseStagesSlice";
import { useLocation, useNavigate } from "react-router-dom";

interface StakeholdersProps {
  userData: any;
  action: string;
  loggedInUserid: any;
  caseStageId: any;
  onCancel: (action: string) => void;
  headerActiveTab: string;
}
interface TeamMember {
  memberuserid: number;
  memberfullname: string;
  memberphonenumber: string;
  memberfaxnumber: string;
  memberemailid: string;
  memberroledesc: string;
}

interface CaseTeamHODDetailsResult {
  tenantId: number;
  caseInfoId: number;
  caseId: string;
  teamId: number;
  teamName: string;
  description: string;
  teamPhoneNumber: string;
  teamFaxNumber: string;
  teamEmailAddress: string;
  hodUserId: number;
  hodFullName: string;
  hodPhoneNumber: string;
  hodFaxNumber: string;
  hodEmailId: string;
  hodRoleDesc: string;
  teamMembersJson: string;
}
const stakeholderTypeMap: { [key: string]: string } = {
  Client: STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY,
  "Applicant Attorney": STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY,
  "Defence Attorney": STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY,
  "Insurance Carrier": STAKEHOLDER_LIST_CODE.INSURANCE,
  "Service Provider": STAKEHOLDER_LIST_CODE.SERVICE_PROVIDER,
};

const Stakeholders: React.FC<StakeholdersProps> = ({
  userData,
  action,
  loggedInUserid,
  caseStageId,
  onCancel,
  headerActiveTab,
}) => {
  const dispatch = useDispatch();
  const dispatchNew = useDispatch<AppDispatch>();
  const { caseInfoId, caseStage } = useSelector(
    (state: RootState) => state.caseHeader
  );
  const { currentStage } = useSelector((state: RootState) => state.caseStages);
  const { view_Case } = useSelector((state: RootState) => state.featureAccess);
  const [isEditable, setIsEditable] = useState<boolean>(
    currentStage === CASE_STAGE_STATUS.NEW
  );
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<string[] | null>(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [result, setResult] = useState<any[]>([]);
  const [client, setClient] = useState<number | null>(null);
  const [clientAddress, setClientAddress] = useState<string[]>([]);
  const [clientContacts, setClientContacts] = useState<string[]>([]);
  const [typeOptions, setTypeOptions] = useState<any[]>([]);
  const [addressOptions, setAddressOptions] = useState<any[]>([]);
  const [contactOptions, setContactOptions] = useState<any[]>([]);
  const [stakeholderData, setStakeholderData] = useState<any>({});

  const [applicant, setApplicant] = useState<number | null>(null);
  const [applicantAddress, setApplicantAddress] = useState<string[]>([]);
  const [applicantContacts, setApplicantContacts] = useState<string[]>([]);
  const [applicantTypeOptions, setApplicantTypeOptions] = useState<any[]>([]);
  const [applicantAddressOptions, setApplicantAddressOptions] = useState<any[]>(
    []
  );
  const [applicantContactOptions, setApplicantContactOptions] = useState<any[]>(
    []
  );
  const [applicantStakeholderData, setApplicantStakeholderData] = useState<any>(
    {}
  );
  const [applicantResult, setApplicantResult] = useState<any[]>([]);

  const [defence, setDefence] = useState<number | null>(null);
  const [defenceAddress, setDefenceAddress] = useState<string[]>([]);
  const [defenceContacts, setDefenceContacts] = useState<string[]>([]);
  const [defencetypeOptions, setDefenceTypeOptions] = useState<any[]>([]);
  const [defenceAddressOptions, setDefenceAddressOptions] = useState<any[]>([]);
  const [defenceContactOptions, setDefenceContactOptions] = useState<any[]>([]);
  const [defenceStakeholderData, setDefenceStakeholderData] = useState<any>({});
  const [defenceResult, setDefenceResult] = useState<any[]>([]);

  const [insurance, setInsurance] = useState<number | null>(null);
  const [insuranceAddress, setInsuranceAddress] = useState<string[]>([]);
  const [insuranceContacts, setInsuranceContacts] = useState<string[]>([]);
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState<any[]>([]);
  const [insuranceAddressOptions, setInsuranceAddressOptions] = useState<any[]>(
    []
  );
  const [insuranceContactOptions, setInsuranceContactOptions] = useState<any[]>(
    []
  );
  const [insuranceStakeholderData, setInsuranceStakeholderData] = useState<any>(
    {}
  );
  const [insuranceResult, setInsuranceResult] = useState<any[]>([]);

  const [service, setService] = useState<number | null>(null);
  const [serviceAddress, setServiceAddress] = useState<string[]>([]);
  const [serviceContacts, setServiceContacts] = useState<string[]>([]);
  const [serviceTypeOptions, setServiceTypeOptions] = useState<any[]>([]);
  const [serviceAddressOptions, setServiceAddressOptions] = useState<any[]>([]);
  const [serviceContactOptions, setServiceContactOptions] = useState<any[]>([]);
  const [serviceStakeholderData, setServiceStakeholderData] = useState<any>({});
  const [serviceResult, setServiceResult] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [tabToClose, setTabToClose] = useState(null);
  const [clientName, setClientName] = useState<string>("");
  const [applicantName, setApplicantName] = useState<string>("");
  const [defenceName, setDefenceName] = useState<string>("");
  const [insuranceName, setInsuranceName] = useState<string>("");
  const [serviceProviderName, setServiceProviderName] = useState<string>("");
  const [teamData, setTeamData] = useState<CaseTeamHODDetailsResult | null>(
    null
  );
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);

  const mergeMissingEntries = (
    resultList: any[],
    existingList: any[],
    setOptions: any,
    idKey: string,
    nameKey: string
  ) => {
    if (!resultList || !existingList) return;

    const existingIds = new Set(existingList?.map((item) => item.value));

    const newEntries = resultList
      ?.filter((item) => item[idKey] && !existingIds.has(item[idKey]))
      ?.map((item) => ({
        value: item[idKey],
        label: item[nameKey],
      }));

    if (newEntries.length > 0) {
      setOptions([...existingList, ...newEntries]);
    }
  };

  const mergeMissingEntriesContacts = (
    existingList: any[],
    newEntries: any[]
  ) => {
    return [...existingList, ...newEntries].filter(
      (item, index, self) =>
        index === self.findIndex((i) => i.value === item.value)
    );
  };

  const extractMissingContacts = (
    contactsJson: any[] = [],
    existingContacts: any[] = []
  ) => {
    return contactsJson
      ?.filter(
        (contact) =>
          contact?.stakeholderContactID &&
          contact?.contactfullname &&
          !existingContacts.some(
            (existing) => existing.value === contact.stakeholderContactID
          )
      )
      ?.map((contact) => ({
        value: contact.stakeholderContactID,
        label: contact.contactfullname,
      }));
  };

  const fetchData = async (stakeholderType?: string) => {
    try {
      if (!caseInfoId) return;
      const stakeholderCodes = {
        client: STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY,
        applicant: STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY,
        defence: STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY,
        insurance: STAKEHOLDER_LIST_CODE.INSURANCE,
        service: STAKEHOLDER_LIST_CODE.SERVICE_PROVIDER,
      };

      const [
        clientDetails,
        applicantDetails,
        defenceDetails,
        insuranceDetails,
        serviceDetails,
      ] = await Promise.all([
        fetchCaseStakeholderDetails(caseInfoId, stakeholderCodes.client),
        fetchCaseStakeholderDetails(caseInfoId, stakeholderCodes.applicant),
        fetchCaseStakeholderDetails(caseInfoId, stakeholderCodes.defence),
        fetchCaseStakeholderDetails(caseInfoId, stakeholderCodes.insurance),
        fetchCaseStakeholderDetails(caseInfoId, stakeholderCodes.service),
      ]);

      setClientName(clientDetails?.[0]?.stakeholderName || "");
      setApplicantName(applicantDetails?.[0]?.stakeholderName || "");
      setDefenceName(defenceDetails?.[0]?.stakeholderName || "");
      setInsuranceName(insuranceDetails?.[0]?.stakeholderName || "");
      setServiceProviderName(serviceDetails?.[0]?.stakeholderName || "");
      dispatch(
        setClient_StakeholderId(clientDetails?.[0]?.stakeholderId || null)
      );

      const [
        stakeholderClientList,
        stakeholderApplicantList,
        stakeholderDefenceList,
        stakeholderInsuranceList,
        stakeholderServiceList,
      ] = await Promise.all([
        fetchCaseStakeholderList(stakeholderCodes.client, 1),
        fetchCaseStakeholderList(STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY, 1),
        fetchCaseStakeholderList(STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY, 1),
        fetchCaseStakeholderList(stakeholderCodes.insurance, 1),
        fetchCaseStakeholderList(stakeholderCodes.service, 1),
      ]);

      stakeholderClientList && setTypeOptions(stakeholderClientList);
      stakeholderApplicantList &&
        setApplicantTypeOptions(stakeholderApplicantList);
      stakeholderDefenceList && setDefenceTypeOptions(stakeholderDefenceList);
      stakeholderInsuranceList &&
        setInsuranceTypeOptions(stakeholderInsuranceList);
      stakeholderServiceList && setServiceTypeOptions(stakeholderServiceList);

      const filteredApplicantOptions = stakeholderApplicantList.filter(
        (applicantOption: any) => applicantOption.value !== defence
      );
      setApplicantTypeOptions(filteredApplicantOptions);

      const filteredDefenceOptions = stakeholderDefenceList.filter(
        (defenceOption: any) => defenceOption.value !== applicant
      );
      setDefenceTypeOptions(filteredDefenceOptions);

      mergeMissingEntries(
        clientDetails,
        stakeholderClientList,
        setTypeOptions,
        "stakeholderId",
        "stakeholderName"
      );
      mergeMissingEntries(
        applicantDetails,
        stakeholderApplicantList,
        setApplicantTypeOptions,
        "stakeholderId",
        "stakeholderName"
      );
      mergeMissingEntries(
        defenceDetails,
        stakeholderDefenceList,
        setDefenceTypeOptions,
        "stakeholderId",
        "stakeholderName"
      );
      mergeMissingEntries(
        insuranceDetails,
        stakeholderInsuranceList,
        setInsuranceTypeOptions,
        "stakeholderId",
        "stakeholderName"
      );
      mergeMissingEntries(
        serviceDetails,
        stakeholderServiceList,
        setServiceTypeOptions,
        "stakeholderId",
        "stakeholderName"
      );

      const fetchAndSetStakeholderData = async (
        details: any[],
        stakeholderList: any[],
        setDataFuncs: any
      ) => {
        const isStakeholderPresent = stakeholderList?.some(
          (item: any) => item.value === details[0]?.stakeholderId
        );
        if (
          details?.length > 0 &&
          details[0]?.stakeholderId &&
          isStakeholderPresent
        ) {
          const stakeholderId = details[0].stakeholderId;

          const [addresses, contacts] = await Promise.all([
            fetchCaseStakeholderAddressList(stakeholderId),
            fetchCaseStakeholderContactList(stakeholderId),
          ]);

          // Extract contacts from contactsJson
          const contactsJson = Array.isArray(details[0]?.contactsJson)
            ? details[0]?.contactsJson
            : [];
          // Get missing contacts from contactsJson
          const missingContacts = extractMissingContacts(
            contactsJson,
            contacts
          );
          // Merge API contacts with missing contacts
          const updatedContacts = mergeMissingEntriesContacts(
            contacts,
            missingContacts
          );

          const {
            setAddressOptions,
            setContactOptions,
            setStakeholderData,
            setResult,
            setStakeholder,
            setStakeholderAddress,
            setStakeholderContacts,
          } = setDataFuncs;
          setAddressOptions(addresses || []);
          setContactOptions(updatedContacts || []);
          setStakeholderData(details);
          setResult(details || []);
          setStakeholder(stakeholderId);
          setStakeholderAddress(
            details[0]?.address_ids
              ? details[0]?.address_ids.split(",").map(Number)
              : []
          );
          setStakeholderContacts(
            details[0]?.contact_ids
              ? details[0]?.contact_ids.split(",").map(Number)
              : []
          );
        }
      };

      await Promise.all([
        fetchAndSetStakeholderData(clientDetails, typeOptions, {
          setAddressOptions: setAddressOptions,
          setContactOptions: setContactOptions,
          setStakeholderData: setStakeholderData,
          setResult: setResult,
          setStakeholder: setClient,
          setStakeholderAddress: setClientAddress,
          setStakeholderContacts: setClientContacts,
        }),
        fetchAndSetStakeholderData(defenceDetails, defencetypeOptions, {
          setAddressOptions: setDefenceAddressOptions,
          setContactOptions: setDefenceContactOptions,
          setStakeholderData: setDefenceStakeholderData,
          setResult: setDefenceResult,
          setStakeholder: setDefence,
          setStakeholderAddress: setDefenceAddress,
          setStakeholderContacts: setDefenceContacts,
        }),
        fetchAndSetStakeholderData(applicantDetails, applicantTypeOptions, {
          setAddressOptions: setApplicantAddressOptions,
          setContactOptions: setApplicantContactOptions,
          setStakeholderData: setApplicantStakeholderData,
          setResult: setApplicantResult,
          setStakeholder: setApplicant,
          setStakeholderAddress: setApplicantAddress,
          setStakeholderContacts: setApplicantContacts,
        }),
        fetchAndSetStakeholderData(insuranceDetails, insuranceTypeOptions, {
          setAddressOptions: setInsuranceAddressOptions,
          setContactOptions: setInsuranceContactOptions,
          setStakeholderData: setInsuranceStakeholderData,
          setResult: setInsuranceResult,
          setStakeholder: setInsurance,
          setStakeholderAddress: setInsuranceAddress,
          setStakeholderContacts: setInsuranceContacts,
        }),
        fetchAndSetStakeholderData(serviceDetails, serviceTypeOptions, {
          setAddressOptions: setServiceAddressOptions,
          setContactOptions: setServiceContactOptions,
          setStakeholderData: setServiceStakeholderData,
          setResult: setServiceResult,
          setStakeholder: setService,
          setStakeholderAddress: setServiceAddress,
          setStakeholderContacts: setServiceContacts,
        }),
      ]);

      if (!serviceDetails?.length) {
        const defaultService = stakeholderServiceList?.find(
          (option: any) =>
            option.label === SERVICE_PROVIDER_DEFAULT.SERVICE_PROVIDER_ACUTRANS
        );

        if (defaultService) {
          const stakeholderId = defaultService?.value;
          const [addresses, contacts] = await Promise.all([
            fetchCaseStakeholderAddressList(stakeholderId),
            fetchCaseStakeholderContactList(stakeholderId),
          ]);
          setServiceAddressOptions(addresses || []);
          setServiceContactOptions(contacts || []);
          setService(stakeholderId);
          setServiceAddress(
            defaultService?.address_ids?.split(",").map(Number) || []
          );
          setServiceContacts(
            defaultService?.contact_ids?.split(",").map(Number) || []
          );
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataaa = async () => {
    try {
      const data = await fetchCaseTeamHODDetails(caseInfoId);
      setTeamData(data);

      const parsedMembers: TeamMember[] = JSON.parse(
        data.teamMembersJson || "[]"
      );
      setTeamMembers(parsedMembers);
    } catch (error) {
      console.error("Error loading team details", error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchDataaa();
  }, []);

  useEffect(() => {
    if (headerActiveTab !== "Parties") return;
    fetchData();
    fetchDataaa();
    setActiveKey(null);
    setIsEditable(currentStage === CASE_STAGE_STATUS.NEW);
  }, [headerActiveTab]);

  useEffect(() => {
    if (isExpanded) {
      fetchData();
    }
  }, [isExpanded]);

  dispatch(setClientId(result[0]?.stakeholderId || ""));

  const handleClientsChange = async (
    event: React.ChangeEvent<HTMLSelectElement>,
    type: string
  ) => {
    const selectedId = Number(event.target.value);

    switch (type) {
      case "client":
        setClient(selectedId);
        break;
      case "applicant":
        setApplicant(selectedId);
        break;
      case "defence":
        setDefence(selectedId);
        break;
      case "insurance":
        setInsurance(selectedId);
        break;
      case "service":
        setService(selectedId);
        break;
      default:
        break;
    }

    try {
      const [addresses, contacts] = await Promise.all([
        fetchCaseStakeholderAddressList(selectedId),
        fetchCaseStakeholderContactList(selectedId),
      ]);
      const singleAddress =
        addresses?.length === 1 ? addresses[0]?.value : null;
      const singleContact = contacts?.length === 1 ? contacts[0]?.value : null;

      switch (type) {
        case "client":
          setAddressOptions(addresses || []);
          setContactOptions(contacts || []);
          setClientAddress(singleAddress ? [singleAddress] : []);
          setClientContacts(singleContact ? [singleContact] : []);
          break;
        case "applicant":
          setApplicantAddressOptions(addresses || []);
          setApplicantContactOptions(contacts || []);
          setApplicantAddress(singleAddress ? [singleAddress] : []);
          setApplicantContacts(singleContact ? [singleContact] : []);
          break;
        case "defence":
          setDefenceAddressOptions(addresses || []);
          setDefenceContactOptions(contacts || []);
          setDefenceAddress(singleAddress ? [singleAddress] : []);
          setDefenceContacts(singleContact ? [singleContact] : []);
          break;
        case "insurance":
          setInsuranceAddressOptions(addresses || []);
          setInsuranceContactOptions(contacts || []);
          setInsuranceAddress(singleAddress ? [singleAddress] : []);
          setInsuranceContacts(singleContact ? [singleContact] : []);
          break;
        case "service":
          setServiceAddressOptions(addresses || []);
          setServiceContactOptions(contacts || []);
          setServiceAddress(singleAddress ? [singleAddress] : []);
          setServiceContacts(singleContact ? [singleContact] : []);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSubmitForClient = async () => {
    await handleSubmit(
      client,
      clientAddress,
      clientContacts,
      stakeholderData,
      setStakeholderData,
      setResult,
      STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY
    );
  };

  const handleSubmitForApplicant = async () => {
    await handleSubmit(
      applicant,
      applicantAddress,
      applicantContacts,
      applicantStakeholderData,
      setApplicantStakeholderData,
      setApplicantResult,
      STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY
    );
  };

  const handleSubmitForDefence = async () => {
    await handleSubmit(
      defence,
      defenceAddress,
      defenceContacts,
      defenceStakeholderData,
      setDefenceStakeholderData,
      setDefenceResult,
      STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY
    );
  };

  const handleSubmitForInsurance = async () => {
    await handleSubmit(
      insurance,
      insuranceAddress,
      insuranceContacts,
      insuranceStakeholderData,
      setInsuranceStakeholderData,
      setInsuranceResult,
      STAKEHOLDER_LIST_CODE.INSURANCE
    );
  };

  const handleSubmitForService = async () => {
    await handleSubmit(
      service,
      serviceAddress,
      serviceContacts,
      serviceStakeholderData,
      setServiceStakeholderData,
      setServiceResult,
      STAKEHOLDER_LIST_CODE.SERVICE_PROVIDER
    );
  };

  const handleSubmit = async (
    stakeholderId: any,
    addressList: any,
    contactList: any,
    stakeholderData: any,
    setStakeholderDataFn: (data: any) => void,
    setResultFn: (data: any[]) => void,
    stakeholderType: string
  ) => {
    if (!stakeholderId) {
      let message = "";
      switch (stakeholderType) {
        case STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY:
          message = "Client is Mandatory";
          break;
        case STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY:
          message = "Applicant Attorney is Mandatory";
          break;
        case STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY:
          message = "Defense Attorney is Mandatory";
          break;
        case STAKEHOLDER_LIST_CODE.INSURANCE:
          message = "Insurance Claim is Mandatory";
          break;
        case STAKEHOLDER_LIST_CODE.SERVICE_PROVIDER:
          message = "Service Provider is Mandatory";
          break;
        default:
          message = "Please select a valid stakeholder.";
      }

      setSnackbar({ open: true, message, type: "error" });
      return;
    }

    if (
      (!addressList || addressList.length === 0) &&
      (!contactList || contactList.length === 0)
    ) {
      setSnackbar({
        open: true,
        message: `Please select at least one Address.\nPlease select at least one Contact.`,
        type: "error",
      });
      return;
    }

    if (!addressList || addressList?.length === 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one Address.",
        type: "error",
      });
      return;
    }

    if (!contactList || contactList?.length === 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one Contact.",
        type: "error",
      });
      return;
    }
    setLoading(true);
    const payload = {
      caseInfoId,
      stakeholderId,
      stakeholderType,
      addressIds: addressList.map(String),
      contactIds: contactList.map(String),
    };

    const payloadUpdate = {
      caseInfoId,
      stakeholderId,
      stakeholderType,
      addressIds: addressList.map(String).join(","),
      contactIds: contactList.map(String).join(","),
      caseStakeholderId: stakeholderData[0]?.caseStakeholderId,
      isActive: stakeholderData[0]?.isActive,
    };

    try {
      const isUpdate = Boolean(stakeholderData[0]?.caseInfoId);
      const response = stakeholderData[0]?.caseInfoId
        ? await updateCaseStakeholderDetails(payloadUpdate)
        : await addCaseStakeholderDetails(payload);

      let successMessage = "";
      switch (stakeholderType) {
        case STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY:
          successMessage = isUpdate
            ? "Client updated successfully."
            : "Client added successfully.";
          break;
        case STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY:
          successMessage = isUpdate
            ? "Applicant Attorney updated successfully."
            : "Applicant Attorney added successfully.";
          break;
        case STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY:
          successMessage = isUpdate
            ? "Defense Attorney updated successfully."
            : "Defense Attorney added successfully.";
          break;
        case STAKEHOLDER_LIST_CODE.INSURANCE:
          successMessage = isUpdate
            ? "Insurance Claim updated successfully."
            : "Insurance Claim added successfully.";
          break;
        case STAKEHOLDER_LIST_CODE.SERVICE_PROVIDER:
          successMessage = isUpdate
            ? "Service Provider updated successfully."
            : "Service Provider added successfully.";
          break;
        default:
          successMessage = isUpdate
            ? "Stakeholder updated successfully."
            : "Stakeholder added successfully.";
      }

      setSnackbar({
        open: true,
        message: response?.isSuccess ? successMessage : response?.message,
        type: response?.isSuccess ? "success" : "error",
      });

      if (response?.isSuccess) {
        dispatchNew(fetchCaseStages(caseInfoId));
        const updatedDetails = await fetchCaseStakeholderDetails(
          caseInfoId,
          stakeholderType
        );
        setStakeholderDataFn(updatedDetails);
        setResultFn(updatedDetails || []);
        fetchDataaa();
      }
    } catch (error) {
      setSnackbar({ open: true, message: "An error occurred", type: "error" });
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const stakeholderTitles = [
    "Client",
    "Applicant Attorney",
    "Defense Attorney",
    "Insurance Carrier",
    "Service Provider",
  ];

  const handleAccordionSelect = (key: string | null) => {
    if (!key) return;
    setActiveKey((prevActiveKey) => {
      const isActive = prevActiveKey && prevActiveKey.includes(key);
      if (isActive) {
        resetSelectedValue(key);
        return prevActiveKey.filter((k) => k !== key);
      }

      return [key];
    });

    if (isExpanded) return;
    const title = stakeholderTitles[parseInt(key, 10)];
    const stakeholderType = stakeholderTypeMap[title];
    if (stakeholderType) {
      fetchData(stakeholderType);
    }
  };

  const resetSelectedValue = (key: string) => {
    const sectionName = sectionMap[key];
    if (sectionName) {
      resetForm(sectionName);
    }
  };

  const handleExpandAll = () => {
    if (isExpanded) {
      setActiveKey(null);
    } else {
      setActiveKey(stakeholderTitles.map((_, index) => index.toString()));
    }
    setIsExpanded(!isExpanded);
  };

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const resetForm = (section: string) => {
    fetchData();
    switch (section) {
      case "client":
        if (result?.length > 0) {
          setClient(result[0]?.stakeholderId);
          setClientAddress(
            result[0]?.address_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          setClientContacts(
            result[0]?.contact_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          return;
        }
        setClient(null);
        setClientAddress([]);
        setClientContacts([]);
        setAddressOptions([]);
        setContactOptions([]);
        break;
      case "applicant":
        if (applicantResult?.length > 0) {
          setApplicant(applicantResult[0]?.stakeholderId);
          setApplicantAddress(
            applicantResult[0]?.address_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          setApplicantContacts(
            applicantResult[0]?.contact_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          return;
        }
        setApplicant(null);
        setApplicantAddress([]);
        setApplicantContacts([]);
        setApplicantAddressOptions([]);
        setApplicantContactOptions([]);
        break;
      case "defence":
        if (defenceResult?.length > 0) {
          setDefence(defenceResult[0]?.stakeholderId);
          setDefenceAddress(
            defenceResult[0]?.address_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          setDefenceContacts(
            defenceResult[0]?.contact_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          return;
        }
        setDefence(null);
        setDefenceAddress([]);
        setDefenceContacts([]);
        setDefenceAddressOptions([]);
        setDefenceContactOptions([]);
        break;
      case "insurance":
        if (insuranceResult?.length > 0) {
          setInsurance(insuranceResult[0]?.stakeholderId);
          setInsuranceAddress(
            insuranceResult[0]?.address_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          setInsuranceContacts(
            insuranceResult[0]?.contact_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          return;
        }
        setInsurance(null);
        setInsuranceAddress([]);
        setInsuranceContacts([]);
        setInsuranceAddressOptions([]);
        setInsuranceContactOptions([]);
        break;
      case "service":
        if (serviceResult?.length > 0) {
          setService(serviceResult[0]?.stakeholderId);
          setServiceAddress(
            serviceResult[0]?.address_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          setServiceContacts(
            serviceResult[0]?.contact_ids
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10))
          );
          return;
        }
        setService(null);
        setServiceAddress([]);
        setServiceContacts([]);
        setServiceAddressOptions([]);
        setServiceContactOptions([]);
        break;
      default:
        break;
    }
  };

  const sectionMap: any = {
    "0": "client",
    "1": "applicant",
    "2": "defence",
    "3": "insurance",
    "4": "service",
  };

  const handleCancel = (tabKey: any) => {
    setTabToClose(tabKey);
    setShowModal(true);
  };

  const handleConfirmCancel = () => {
    if (activeKey && activeKey?.length > 0) {
      const activeSection = activeKey[0];
      const sectionName = sectionMap[activeSection];
      if (sectionName) {
        resetForm(sectionName);
      }
      setActiveKey(
        (activeKey || []).filter((key) => key.toString() !== tabToClose)
      );
    }
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const navigate = useNavigate();

  const location = useLocation();

  const handleReviewerBack = () => {
    dispatch(setIsDashboard(false));
    dispatch(setNewCaseInFoID(null));

    navigate("/mytodos", {
      state: location.state, // pass it back
    });
  };

  const isFromRecordReviewer = location.state?.from === "mytodos";

  const handleBack = () => {
    onCancel("Cancel");
  };

  const getStakeholderState = (stakeholderData: any) => {
    const stakeholderId = stakeholderData[0]?.stakeholderId || null;
    const stakeholderAddressArray = stakeholderData[0]?.address_ids
      ? stakeholderData[0].address_ids.split(",").map(Number)
      : [];
    const stakeholderContactsArray = stakeholderData[0]?.contact_ids
      ? stakeholderData[0].contact_ids.split(",").map(Number)
      : [];

    return { stakeholderId, stakeholderAddressArray, stakeholderContactsArray };
  };

  const isStakeholderSame = (
    stakeholder: number | null,
    stakeholderAddress: string[],
    stakeholderContacts: string[],
    stakeholderData: any
  ) => {
    const { stakeholderId, stakeholderAddressArray, stakeholderContactsArray } =
      getStakeholderState(stakeholderData);

    return (
      stakeholder === stakeholderId &&
      JSON.stringify(stakeholderAddress) ===
      JSON.stringify(stakeholderAddressArray) &&
      JSON.stringify(stakeholderContacts) ===
      JSON.stringify(stakeholderContactsArray)
    );
  };

  const isDisabledClient =
    !client ||
    isStakeholderSame(client, clientAddress, clientContacts, stakeholderData);
  const isDisabledApplicant =
    !applicant ||
    isStakeholderSame(
      applicant,
      applicantAddress,
      applicantContacts,
      applicantStakeholderData
    );
  const isDisabledDefence =
    !defence ||
    isStakeholderSame(
      defence,
      defenceAddress,
      defenceContacts,
      defenceStakeholderData
    );
  const isDisabledInsurance =
    !insurance ||
    isStakeholderSame(
      insurance,
      insuranceAddress,
      insuranceContacts,
      insuranceStakeholderData
    );
  const isDisabledService =
    !service ||
    isStakeholderSame(
      service,
      serviceAddress,
      serviceContacts,
      serviceStakeholderData
    );

  const [partyType, setPartyType] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [showPartyModal, setShowPartyModal] = useState(false);

  const [partyHeaderID, setPartyHeaderID] = useState(null);
  const [hasAddressData, setHasAddressData] = useState(false);
  const [hasContactData, setHasContactData] = useState(false);

  const updatePartyTypeState = async (id: any, type: string) => {
    if (!(partyHeaderID && hasAddressData && hasContactData)) return;

    const numericId = Number(id);

    const [addresses, contacts] = await Promise.all([
      fetchCaseStakeholderAddressList(numericId),
      fetchCaseStakeholderContactList(numericId),
    ]);

    const addressValues =
      addresses?.map((a: { value: number }) => a.value) || [];
    const contactValues =
      contacts?.map((c: { value: number }) => c.value) || [];

    switch (type) {
      case PARTY_TYPES.CLIENT:
        setClient(numericId);
        setAddressOptions(addresses);
        setClientAddress(addressValues);
        setContactOptions(contacts);
        setClientContacts(contactValues);
        break;

      case PARTY_TYPES.Applicant_Attorney:
        setApplicant(numericId);
        setApplicantAddressOptions(addresses);
        setApplicantAddress(addressValues);
        setApplicantContactOptions(contacts);
        setApplicantContacts(contactValues);
        break;

      case PARTY_TYPES.Défense_Attorney:
        setDefence(numericId);
        setDefenceAddressOptions(addresses);
        setDefenceAddress(addressValues);
        setDefenceContactOptions(contacts);
        setDefenceContacts(contactValues);
        break;

      case PARTY_TYPES.INSURANCE:
        setInsurance(numericId);
        setInsuranceAddressOptions(addresses);
        setInsuranceAddress(addressValues);
        setInsuranceContactOptions(contacts);
        setInsuranceContacts(contactValues);
        break;

      default:
        break;
    }
  };

  const handlePartyDrawerClose = async () => {
    if (partyHeaderID && (!hasAddressData || !hasContactData)) {
      setShowPartyModal(true);
      await fetchData(); // Ensure modal still gets latest data
    } else {
      setShowDrawer(false);
      await fetchData(); // ⬅️ Wait for options like insuranceTypeOptions to be updated
      updatePartyTypeState(partyHeaderID, partyType); // ⬅️ Then set the ID
    }
  };

  const handlePartyConfirmCancel = () => {
    setShowPartyModal(false);
    setShowDrawer(false);
    fetchData();
  };

  const handlePartyCloseModal = () => {
    setShowPartyModal(false);
    fetchData();
  };

  const openDrawerWithType = (type: string) => {
    setPartyType(type);
    setShowDrawer(true);
    setPartyHeaderID(null);
    setHasAddressData(false);
    setHasContactData(false);
    fetchData();
  };
  const [cotaintKey, setcotaintKey] = useState<string | null>("0");

  const cotaintAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={cotaintKey}
      onSelect={(key) => setcotaintKey(key as string)}
    />
  );

  const [containClientKey, setcontainClientKey] = useState<string | null>("0");

  const containClientAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={containClientKey}
      onSelect={(key) => setcontainClientKey(key as string)}
    />
  );

  const [applicantattorneydetailKey, setapplicantattorneydetailKey] = useState<
    string | null
  >("0");

  const applicantattorneydetailKeyAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={applicantattorneydetailKey}
      onSelect={(key) => setapplicantattorneydetailKey(key as string)}
    />
  );

  const [insuranceclaimdetailKey, setinsuranceclaimKey] = useState<
    string | null
  >("0");

  const insuranceclaimKeyAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={insuranceclaimdetailKey}
      onSelect={(key) => setinsuranceclaimKey(key as string)}
    />
  );

  const [insuranceCarrierKey, setinsuranceCarrierKey] = useState<string | null>(
    "0"
  );

  const insuranceCarrierKeyAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={insuranceCarrierKey}
      onSelect={(key) => setinsuranceCarrierKey(key as string)}
    />
  );

  const [defenceattorneyKey, setdefenceattorneyKey] = useState<string | null>(
    null
  );

  const defenceattorneyAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={defenceattorneyKey}
      onSelect={(key) => setdefenceattorneyKey(key as string)}
    />
  );

  return (
    <>
      <Container fluid className="position-relative pb-5">
        <Loader isLoading={loading} />
        <Row className="my-0">
          <Col>
            <button
              type="button"
              className="btn d-flex align-items-center btn-text-border float-end position-absolute"
              onClick={handleExpandAll}
              style={{ top: "-50px", right: "0px", padding: "3px 5px" }}
            >
              <span className="material-symbols-outlined">
                {isExpanded ? "expand_all" : "collapse_all"}
              </span>
            </button>
          </Col>
        </Row>
        <Row>
          <Col className="px-0">
            <AccordionComponent
              items={[
                {
                  title:
                    activeKey?.includes("0") || !clientName ? (
                      "Client"
                    ) : (
                      <>
                        Client - <span className="fw-normal">{clientName}</span>
                      </>
                    ),
                  content: (
                    <>
                      <Row>
                        <Col sm={4} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Client"
                            value={client || ""}
                            options={typeOptions}
                            name="client"
                            required
                            onChange={(event) =>
                              handleClientsChange(event, "client")
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={8} className="selection_dropdown">
                          <SearchableMultiSelectDropdown
                            label="Address"
                            values={clientAddress}
                            options={addressOptions}
                            name="clientAddress"
                            required
                            onChange={(e: any) =>
                              setClientAddress(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={4} className="selection_dropdown mt-4">
                          <SearchableMultiSelectDropdown
                            label="Contacts"
                            values={clientContacts}
                            options={contactOptions}
                            name="clientContacts"
                            required
                            onChange={(e: any) =>
                              setClientContacts(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col className="d-flex  my-3">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                              {isEditable ? (
                                <Button
                                  variant="primary"
                                  className="d-flex align-items-center"
                                  onClick={() =>
                                    openDrawerWithType(PARTY_TYPES.CLIENT)
                                  }
                                  disabled={view_Case}
                                >
                                  <span className="material-symbols-outlined">
                                    add_circle
                                  </span>{" "}
                                  Register New Client
                                </Button>
                              ) : (
                                <div style={{ width: "180px" }}></div> // Empty placeholder to preserve layout
                              )}
                            </div>
                            <div className="d-flex">
                              <Button
                                variant="outline-info"
                                className="d-flex align-items-center"
                                onClick={() => handleCancel("0")}
                                disabled={
                                  isDisabledClient || !isEditable || view_Case
                                }
                              >
                                <span className="material-icons mr-2">
                                  close
                                </span>{" "}
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                className="ml-3 d-flex align-items-center mx-2"
                                onClick={handleSubmitForClient}
                                disabled={
                                  isDisabledClient || !isEditable || view_Case
                                }
                              >
                                <span className="material-icons mx-1">
                                  save
                                </span>{" "}
                                Save
                              </Button>
                            </div>
                          </div>
                        </Col>

                        {result?.length > 0 ? (
                          <>
                            {containClientAccordion([
                              {
                                title: "Details",
                                content: (
                                  <>
                                    <StakeholderCardDetails
                                      result={result}
                                      StakeholderName={"Client"}
                                    />
                                  </>
                                ),
                              },
                            ])}
                          </>
                        ) : (
                          ""
                        )}
                      </Row>
                    </>
                  ),
                },
                {
                  title:
                    activeKey?.includes("1") || !applicantName ? (
                      "Applicant Attorney"
                    ) : (
                      <>
                        Applicant Attorney -{" "}
                        <span className="fw-normal">{applicantName}</span>
                      </>
                    ),

                  content: (
                    <>
                      <Row>
                        <Col sm={4} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Applicant Attorney"
                            value={applicant || ""}
                            options={applicantTypeOptions}
                            name="applicant"
                            required
                            onChange={(event) =>
                              handleClientsChange(event, "applicant")
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={8} className="selection_dropdown">
                          <SearchableMultiSelectDropdown
                            label="Address"
                            values={applicantAddress}
                            options={applicantAddressOptions}
                            name="applicantAddress"
                            required
                            onChange={(e: any) =>
                              setApplicantAddress(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={4} className="selection_dropdown mt-4">
                          <SearchableMultiSelectDropdown
                            label="Contacts"
                            values={applicantContacts}
                            options={applicantContactOptions}
                            name="applicantContacts"
                            required
                            onChange={(e: any) =>
                              setApplicantContacts(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                      </Row>

                      <Row className="my-3">
                        <Col className="d-flex my-3">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            {/* Left-aligned button or placeholder */}
                            <div>
                              {isEditable ? (
                                <Button
                                  variant="primary"
                                  className="d-flex align-items-center"
                                  onClick={() =>
                                    openDrawerWithType(
                                      PARTY_TYPES.Applicant_Attorney
                                    )
                                  }
                                  disabled={view_Case}
                                >
                                  <span className="material-symbols-outlined me-1">
                                    add_circle
                                  </span>
                                  Register New Applicant Attorney
                                </Button>
                              ) : (
                                <div style={{ width: "180px" }}></div> // Empty placeholder to preserve layout
                              )}
                            </div>

                            {/* Right-aligned buttons */}
                            <div className="d-flex">
                              <Button
                                variant="outline-info"
                                className="d-flex align-items-center me-2"
                                onClick={() => handleCancel("1")}
                                disabled={
                                  isDisabledApplicant ||
                                  !isEditable ||
                                  view_Case
                                }
                              >
                                <span className="material-icons me-1">
                                  close
                                </span>
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                className="d-flex align-items-center"
                                onClick={handleSubmitForApplicant}
                                disabled={
                                  isDisabledApplicant ||
                                  !isEditable ||
                                  view_Case
                                }
                              >
                                <span className="material-icons me-1">
                                  save
                                </span>
                                Save
                              </Button>
                            </div>
                          </div>
                        </Col>

                        {applicantResult?.length > 0 ? (
                          <>
                            {applicantattorneydetailKeyAccordion([
                              {
                                title: "Details",
                                content: (
                                  <>
                                    <StakeholderCardDetails
                                      result={applicantResult}
                                      StakeholderName={"Applicant Attorney"}
                                    />
                                  </>
                                ),
                              },
                            ])}
                          </>
                        ) : (
                          ""
                        )}
                      </Row>
                    </>
                  ),
                },
                {
                  title:
                    activeKey?.includes("2") || !defenceName ? (
                      "Defense Attorney"
                    ) : (
                      <>
                        Defense Attorney -{" "}
                        <span className="fw-normal">{defenceName}</span>
                      </>
                    ),

                  content: (
                    <>
                      <Row>
                        <Col sm={4} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Defense"
                            value={defence || ""}
                            options={defencetypeOptions}
                            name="defence"
                            required
                            onChange={(event) =>
                              handleClientsChange(event, "defence")
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={8} className="selection_dropdown">
                          <SearchableMultiSelectDropdown
                            label="Address"
                            values={defenceAddress}
                            options={defenceAddressOptions}
                            name="defenceAddress"
                            required
                            onChange={(e: any) =>
                              setDefenceAddress(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={4} className="selection_dropdown mt-4">
                          <SearchableMultiSelectDropdown
                            label="Contacts"
                            values={defenceContacts}
                            options={defenceContactOptions}
                            name="defenceContacts"
                            required
                            onChange={(e: any) =>
                              setDefenceContacts(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col className="d-flex">
                          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                            {isEditable ? (
                              <Button
                                variant="primary"
                                className="d-flex align-items-center me-auto"
                                onClick={() =>
                                  openDrawerWithType(
                                    PARTY_TYPES.Défense_Attorney
                                  )
                                }
                                disabled={view_Case}
                              >
                                <span className="material-symbols-outlined">
                                  add_circle
                                </span>{" "}
                                Register New Defense Attorney
                              </Button>
                            ) : (
                              <div style={{ width: "180px" }}></div> // Empty placeholder to preserve layout
                            )}
                            <div className="d-flex">
                              <Button
                                variant="outline-info"
                                className="d-flex align-items-center"
                                onClick={() => handleCancel("2")}
                                disabled={
                                  isDisabledDefence || !isEditable || view_Case
                                }
                              >
                                <span className="material-icons mr-2">
                                  close
                                </span>{" "}
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                className="ml-3 d-flex align-items-center mx-2"
                                onClick={handleSubmitForDefence}
                                disabled={
                                  isDisabledDefence || !isEditable || view_Case
                                }
                              >
                                <span className="material-icons mx-1">
                                  save
                                </span>{" "}
                                Save
                              </Button>
                            </div>
                          </div>
                        </Col>
                        {defenceResult?.length > 0 ? (
                          <>
                            {defenceattorneyAccordion([
                              {
                                title: "Details",
                                content: (
                                  <>
                                    <StakeholderCardDetails
                                      result={defenceResult}
                                      StakeholderName={"Defense Attorney"}
                                    />
                                  </>
                                ),
                              },
                            ])}
                          </>
                        ) : (
                          ""
                        )}
                      </Row>
                    </>
                  ),
                },
                {
                  title:
                    activeKey?.includes("3") || !insuranceName ? (
                      "Insurance Carrier"
                    ) : (
                      <>
                        Insurance Carrier -{" "}
                        <span className="fw-normal">{insuranceName}</span>
                      </>
                    ),
                  content: (
                    <>
                      <Row>
                        <Col sm={4} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Insurance"
                            value={insurance || ""}
                            options={insuranceTypeOptions}
                            name="insurance"
                            required
                            onChange={(event) =>
                              handleClientsChange(event, "insurance")
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={8} className="selection_dropdown">
                          <SearchableMultiSelectDropdown
                            label="Address"
                            values={insuranceAddress}
                            options={insuranceAddressOptions}
                            name="insuranceAddress"
                            required
                            onChange={(e: any) =>
                              setInsuranceAddress(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={4} className="selection_dropdown mt-4">
                          <SearchableMultiSelectDropdown
                            label="Adjuster"
                            values={insuranceContacts}
                            options={insuranceContactOptions}
                            name="insuranceContacts"
                            required
                            onChange={(e: any) =>
                              setInsuranceContacts(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col className="d-flex my-3">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                              {isEditable ? (
                                <Button
                                  variant="primary"
                                  className="d-flex align-items-center me-auto"
                                  onClick={() =>
                                    openDrawerWithType(PARTY_TYPES.INSURANCE)
                                  }
                                  disabled={view_Case}
                                >
                                  <span className="material-symbols-outlined">
                                    add_circle
                                  </span>{" "}
                                  Register New Insurance Carrier
                                </Button>
                              ) : (
                                <div style={{ width: "180px" }}></div> // Empty placeholder to preserve layout
                              )}
                            </div>
                            <div className="d-flex">
                              <Button
                                variant="outline-info"
                                className="d-flex align-items-center"
                                onClick={() => handleCancel("3")}
                                disabled={
                                  isDisabledInsurance ||
                                  !isEditable ||
                                  view_Case
                                }
                              >
                                <span className="material-icons mr-2">
                                  close
                                </span>{" "}
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                className="ml-3 d-flex align-items-center mx-2"
                                onClick={handleSubmitForInsurance}
                                disabled={
                                  isDisabledInsurance ||
                                  !isEditable ||
                                  view_Case
                                }
                              >
                                <span className="material-icons mx-1">
                                  save
                                </span>{" "}
                                Save
                              </Button>
                            </div>
                          </div>
                        </Col>

                        {insuranceResult?.length > 0 &&
                          insuranceCarrierKeyAccordion([
                            {
                              title: "Details",
                              content: (
                                <StakeholderCardDetails
                                  result={insuranceResult}
                                  StakeholderName="Insurance Carrier"
                                />
                              ),
                            },
                          ])}
                      </Row>
                    </>
                  ),
                },
                {
                  title:
                    activeKey?.includes("4") || !serviceProviderName ? (
                      "Service Provider"
                    ) : (
                      <>
                        Service Provider -{" "}
                        <span className="fw-normal">{serviceProviderName}</span>
                      </>
                    ),
                  content: (
                    <>
                      <Row>
                        <Col sm={4} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Service Provider"
                            value={service || ""}
                            options={serviceTypeOptions}
                            name="service"
                            required
                            onChange={(event) =>
                              handleClientsChange(event, "service")
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={8} className="selection_dropdown">
                          <SearchableMultiSelectDropdown
                            label="Address"
                            values={serviceAddress}
                            options={serviceAddressOptions}
                            name="serviceAddress"
                            required
                            onChange={(e: any) =>
                              setServiceAddress(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                        <Col sm={4} className="selection_dropdown mt-4">
                          <SearchableMultiSelectDropdown
                            label="Contacts"
                            values={serviceContacts}
                            options={serviceContactOptions}
                            name="serviceContacts"
                            required
                            onChange={(e: any) =>
                              setServiceContacts(e.target.value)
                            }
                            disabled={!isEditable || view_Case}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col className="d-flex my-3">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                              {isEditable ? (
                                <Button
                                  variant="primary"
                                  className="d-flex align-items-center me-auto"
                                  onClick={() =>
                                    openDrawerWithType(PARTY_TYPES.Service_Provider)
                                  }
                                  disabled={view_Case}
                                >
                                  <span className="material-symbols-outlined">
                                    add_circle
                                  </span>{" "}
                                  Register New Service  Provider
                                </Button>
                              ) : (
                                <div style={{ width: "180px" }}></div> // Empty placeholder to preserve layout
                              )}
                            </div>
                            <div className="d-flex">
                              <Button
                                variant="outline-info"
                                className="d-flex align-items-center"
                                onClick={() => handleCancel("4")}
                                disabled={
                                  isDisabledService || !isEditable || view_Case
                                }
                              >
                                <span className="material-icons mr-2">close</span>{" "}
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                className="ml-3 d-flex align-items-center mx-2"
                                onClick={handleSubmitForService}
                                disabled={
                                  isDisabledService || !isEditable || view_Case
                                }
                              >
                                <span className="material-icons mx-1">save</span>{" "}
                                Save
                              </Button>
                            </div>
                          </div>
                        </Col>



                        {cotaintAccordion([
                          {
                            title: "Details",
                            content: (
                              <>
                                {serviceResult?.length > 0 ? (
                                  <>
                                    <StakeholderCardDetails
                                      result={serviceResult}
                                      StakeholderName={"Service Provider"}
                                    />
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            ),
                          },
                        ])}

                        <AccordionComponent
                          items={[
                            {
                              title: "Team information",
                              content: (
                                <>
                                  <Row className="mb-3">
                                    <Col sm={4}>
                                      <div>
                                        <strong>Name</strong>
                                      </div>
                                      <div>{teamData?.teamName}</div>
                                    </Col>
                                    <Col sm={8}>
                                      <div>
                                        <strong>Description</strong>
                                      </div>
                                      <div>{teamData?.description}</div>
                                    </Col>
                                  </Row>

                                  <Row className="mb-3">
                                    <Col sm={4}>
                                      <div>
                                        <strong>Email ID</strong>
                                      </div>
                                      <div>{teamData?.teamEmailAddress}</div>
                                    </Col>
                                    <Col sm={4}>
                                      <div>
                                        <strong>Phone</strong>
                                      </div>
                                      <div>{teamData?.teamPhoneNumber}</div>
                                    </Col>
                                    <Col sm={4}>
                                      <div>
                                        <strong>Fax #</strong>
                                      </div>
                                      <div>{teamData?.teamFaxNumber}</div>
                                    </Col>
                                  </Row>

                                  <Row className="bg-theme mb-3 py-2">
                                    <Col xs={12} className="mb-2">
                                      <span
                                        style={{
                                          color: "#007bff",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Team Leader
                                      </span>{" "}
                                      <span style={{ fontWeight: 500 }}>
                                        {teamData?.hodFullName}
                                      </span>
                                    </Col>
                                    <Col sm={4}>
                                      <div>
                                        <strong>Email ID</strong>
                                      </div>
                                      <div>{teamData?.hodEmailId}</div>
                                    </Col>
                                    <Col sm={4}>
                                      <div>
                                        <strong>Phone</strong>
                                      </div>
                                      <div>{teamData?.hodPhoneNumber}</div>
                                    </Col>
                                    <Col sm={4}>
                                      <div>
                                        <strong>Fax #</strong>
                                      </div>
                                      <div>{teamData?.hodFaxNumber}</div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <AccordionComponent
                                      items={[
                                        {
                                          title: (
                                            <>
                                              Team Members -{" "}
                                              <span className="primary-badge badge rounded-pill bg-primary">
                                                {teamMembers.length}
                                              </span>
                                            </>
                                          ),
                                          content: (
                                            <>
                                              <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                                                <h3 className="mr-2 me-auto">
                                                  List
                                                </h3>
                                              </div>
                                              <DataTable
                                                headers={TEAM_MEMBERS_HEADERS}
                                                rows={teamMembers}
                                              />
                                            </>
                                          ),
                                        },
                                      ]}
                                    />
                                  </Row>
                                </>
                              ),
                            },
                          ]}
                        />
                      </Row>

                    </>
                  ),
                },
              ]}
              activeKey={activeKey}
              onSelect={handleAccordionSelect}
            />
          </Col>
        </Row>
        {userData?.caseInfoId ? (
          <Row>
            <Col md={12} className="px-0">
              <Button
                variant="outline"
                className="d-flex align-items-center btn-text-border me-1"
                onClick={isFromRecordReviewer ? handleReviewerBack : handleBack}
                disabled={!userData?.caseInfoId}
              >
                <span className="material-icons mr-2 ">arrow_back</span>
                Back
              </Button>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModal}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancel}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.type}
        onClose={handleCloseSnackbar}
      />
      <NewPartiesDrawer
        title={"Party"}
        open={showDrawer}
        onClose={handlePartyDrawerClose}
        placement="end"
      >
        <AddNewPartyClient
          partyTypes={partyType}
          setPartyID={setPartyHeaderID}
          setHasAddressData={setHasAddressData}
          setHasContactData={setHasContactData}
          onBack={handlePartyDrawerClose}
        />
      </NewPartiesDrawer>

      <Modal show={showPartyModal} onHide={handlePartyCloseModal}>
        <Modal.Body className="fw-bold text-left modelheading">
          <div>
            {!hasAddressData && !hasContactData
              ? "You haven't filled Address and Contact details. Are you sure you want to cancel the form?"
              : !hasAddressData
                ? "You haven't filled Address details. Are you sure you want to cancel the form?"
                : !hasContactData
                  ? "You haven't filled Contact details. Are you sure you want to cancel the form?"
                  : "Are you sure you want to cancel the form?"}
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={handlePartyCloseModal}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handlePartyConfirmCancel}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Stakeholders;
